import ReactGA from 'react-ga';
import { inProduction } from 'shared/helpers/utils';
import history from './history';
import store from './store';
import { getUser } from './store/modules/pages/reducer';

inProduction(() => {
  const trackingId = 'UA-73641858-1';
  ReactGA.initialize(trackingId, {});

  const fieldsObject = {
    user: null
  };
  const user = getUser(store.getState());
  if (user) fieldsObject.user = user;
  ReactGA.set(fieldsObject);

  history.listen(location => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  });
});
